export default {
  "pl": {
    "contact": {
      "actions": {
        "accept": "OK",
        "add": "Dodaj kontakt",
        "backInspirationLists": "Wróć do list inspiracji",
        "cancelNew": "Cofnij",
        "deactivateEmployee": "Dezaktywuj członka zespołu...",
        "deleteCustomer": "Usuń klienta...",
        "deleteEmployee": "Usuń członka zespołu...",
        "deletePartner": "Usuń partnera...",
        "impersonateStart": "Widok roli",
        "impersonateStop": "Opuść widok roli",
        "newTicket": "Nowa rozmowa",
        "reactivateEmployee": "Reaktywuj członka zespołu…",
        "resendInvitationEmail": "Ponownie wyślij wiadomości e-mail z zaproszeniem",
        "searchContact": "Wyszukaj kontakt",
        "searchCustomer": "Wyszukaj klienta",
        "searchEmployee": "Wyszukaj członka zespołu",
        "selectOption": "Wybierz opcję",
        "setProfilePicture": "Ustaw zdjęcie profilowe",
        "showall": "Pokaż wszystkie"
      },
      "attributes": {
        "language": "Język",
        "timezone": "Strefa czasowa",
        "title": "Tytuł"
      },
      "labels": {
        "address": "Adres",
        "all": "Wszystkie kontakty",
        "company": "Firma",
        "contact_status": {
          "active": "Aktywny",
          "added": "Nie zaproszono",
          "all": "Każdy status",
          "blocked": "Nieaktywny",
          "invited": "Zaproszono",
          "status": "Status"
        },
        "contact_type": "Rodzaj",
        "customer": "Klient",
        "employee": "Zespół",
        "export_contacts": "Eksportuj kontakty",
        "general": "Ogólne",
        "inviteProfileFirstCustomer": "Aby wysłać wiadomość, skorzystać z widoku roli lub ponownie wysłać e-mail z zaproszeniem, najpierw zaproś klienta do korzystania z platformy",
        "inviteProfileFirstPartner": "Aby skorzystać z widoku roli lub ponownie wysłać e-mail z zaproszeniem, najpierw zaproś partnera do korzystania z platformy",
        "last_seen": "ostatnie logowanie",
        "last_seen_not_seen_yet": "użytkownik jeszcze się nie logował",
        "noContacts": "Brak kontaktów",
        "no_contacts": "Brak kontaktów do eksportu",
        "number_contacts": "Brak kontaktów | 1 kontakt | Liczba kontaktów: {count}",
        "other": "Inne",
        "partner": "Partner",
        "project": "Projekt",
        "secondary_contact": "Dodatkowa osoba kontaktowa"
      },
      "navigation": {
        "backToContacts": "Powrót do kontaktów"
      },
      "placeholders": {
        "byNameOrEmailAddress": "Według nazwiska lub adresu e-mail"
      },
      "validation": {
        "emailTaken": "Adres e-mail nie różni się od poprzedniego",
        "mustBeEmailAddress": "Należy podać poprawny adres e-mail",
        "requireEmailAddress": "Należy podać adres e-mail"
      }
    }
  }
}
